import type { DesignProject } from "../types/design";

export const figmaFile = "https://www.figma.com/design/1xaw6Z8u7WkdXJgEE3nKWX/Syed-Muhammad-Zeeshan";

/** Product design work. Each card opens its frame in the source Figma file. */
export const designProjects: DesignProject[] = [
  {
    id: "eposting",
    index: "001",
    title: "ePosting Referral Marketplace",
    tags: ["DESKTOP", "MOBILE", "DASHBOARD"],
    href: `${figmaFile}?node-id=44-92510`,
    plate: "productDesignPlate",
  },
  {
    id: "kds",
    index: "002",
    title: "KDS Revamped",
    tags: ["DESIGN SYSTEM", "FROM SCRATCH"],
    href: `${figmaFile}?node-id=0-1`,
    plate: "chromePlate",
  },
  {
    id: "taskutark",
    index: "003",
    title: "TaskuTark eLearning LMS Platform",
    tags: ["WEB", "MOBILE", "LMS"],
    href: `${figmaFile}?node-id=201-210648`,
    plate: "materialStudy",
  },
  {
    id: "kiosk",
    index: "004",
    title: "Kiosk Redesign",
    tags: ["KIOSK", "TOUCH UI"],
    href: `${figmaFile}?node-id=2-264273`,
    plate: "archivePlate",
  },
  {
    id: "belmonte",
    index: "005",
    title: "Belmonte Real Estate Web App",
    tags: ["WEB APP", "DUBAI"],
    href: `${figmaFile}?node-id=98-147442`,
    plate: "particlePlate",
  },
  {
    id: "notfit",
    index: "006",
    title: "NotFit Fitness Mobile App",
    tags: ["MOBILE", "FITNESS"],
    href: `${figmaFile}?node-id=5-62703`,
    plate: "studioLight",
  },
];
